'use strict';

import gsap from 'gsap';
import {
    Buildings,
    cardsData,
    isDesktop,
    isMobile,
    isNoMenu,
    isWeb,
    projectMode,
    settingsData,
    threeJsVariables,
    UIRoot,
} from '../../../settings';
import {
    changeBorderRadius, isCylinderDisplayModeEqual,
    setParametersDependsOnCanvasArea,
    userPrevent,
} from '../../../functions';
import {UnitCardClass} from "../../cards/unitCards/UnitCardClass";
import { getCurrentLang } from '../langSwitcher/langSwitcher';

export const BuildingSwitch = {
    add: function (container) {
        if (!document.getElementById('building-switcher')) {
            let buildings_list_html = '';
            let buildingsCounter = 0;

            Buildings.getBuildingsArray().forEach((building, i) => {
                let towerName;

                if (building.getInfo().crm_data) {
                    if (Array.isArray(building.info.towerName)){
                        towerName = building.info.towerName.find(el => el.lang === getCurrentLang()).value;
                    } else {
                        towerName = building.info.towerName;
                    }

                    buildings_list_html += `<div class="building-item" data-building="${building.name}" data-index="${buildingsCounter}"><span>${towerName}</span></div>`;
                    buildingsCounter++;
                }
            });

            container.insertAdjacentHTML('beforeend', `
                <div id="building-switcher" class="non-canvas ${isMobile ? 'background-backdrop-filter': ''} ${isNoMenu ? 'no-menu-mode': ''}">
                    <button class="prev-btn new-ui-direction-btn icon-left1"></button>
                    <div class="buildings-list">${buildings_list_html}</div>
                    <button class="next-btn new-ui-direction-btn icon-right1"></button>
                    <div class="buildings-dropdown-wrapper">
                        <div class="buildings-dropdown">${buildings_list_html}</div>
                    </div>
                </div>
            `);

            container.querySelector('#building-switcher .buildings-dropdown-wrapper').addEventListener('click', (event) => {
                const targetWrapper = event.target.closest('.buildings-dropdown-wrapper');
                if (targetWrapper) {
                    const visible = targetWrapper.getAttribute('visible') === 'true' ? true : false;
                    targetWrapper.setAttribute('visible', !visible);
                    if (visible === false) {
                        return;
                    }
                }
                const targetItem = event.target.closest('.building-item');
                if (targetItem) {
                    if (targetItem.classList.contains('active')) {
                        targetWrapper.setAttribute('visible', true);
                    }else {
                        const targetName = targetItem.getAttribute('data-building');
                        projectMode.Cylinder.switchBuilding(targetName);
                    }
                }
            });

            if (isWeb) {
                container.querySelector('#building-switcher .buildings-dropdown-wrapper').addEventListener('mouseenter', (event) => {
                    event.target.closest('.buildings-dropdown-wrapper')?.setAttribute('visible', true);
                });
                container.querySelector('#building-switcher .buildings-dropdown-wrapper').addEventListener('mouseleave', (event) => {
                    event.target.closest('.buildings-dropdown-wrapper')?.setAttribute('visible', false);
                });
            }

            if (Buildings.getBuildingsInfoLength() <= 1) {
                document.querySelector('#building-switcher').classList.add('hide');
            }

            document.querySelector('#building-switcher .buildings-list .building-item').classList.add("active");
            document.querySelector('#building-switcher .buildings-dropdown .building-item').classList.add("active");

            let nav_btns = document.querySelectorAll('#building-switcher .new-ui-direction-btn');
            if (nav_btns) {
                nav_btns.forEach(btn => {
                    btn.addEventListener('click', switchArrowClickHandler);
                });
            }
            changeBorderRadius(document.getElementById('building-switcher'));

            return document.querySelector('#building-switcher');
        }
    },

    changeLanguage: function() {
        const items = document.querySelectorAll('.building-item');

        items.forEach(item => {
            const dataName = item.getAttribute('data-building');
            const buildingInfo = Buildings.getBuilding(dataName).info;

            let name;

            if (Array.isArray(buildingInfo.towerName) && buildingInfo.towerName.length){
                name = buildingInfo.towerName.find(name => name.lang === getCurrentLang()).value;
            } else {
                name = buildingInfo.towerName;
            }

            item.firstElementChild.textContent = name;
        });
    }
}

const switchArrowClickHandler = (event) => {
    if (userPrevent() || settingsData.activeModeSwitching)
        return;

    settingsData.activeModeSwitching = true;

    const items_list = document.querySelectorAll('#building-switcher .buildings-list .building-item');
    const active_item = document.querySelector('#building-switcher .building-item.active');
    if (event.target.classList.contains('next-btn')) {
        let target_index = Number(active_item.getAttribute('data-index')) + 1;
        if (items_list.length === target_index)
            target_index = 0;

        const targetName = document.querySelector(`.building-item[data-index="${target_index}"]`).getAttribute('data-building');
        projectMode.Cylinder.switchBuilding(targetName);

    } else if (event.target.classList.contains('prev-btn')) {
        let target_index = Number(active_item.getAttribute('data-index')) - 1;
        if (target_index < 0)
            target_index = items_list.length - 1;

        const targetName = document.querySelector(`.building-item[data-index="${target_index}"]`).getAttribute('data-building');
        projectMode.Cylinder.switchBuilding(targetName);
    }
}

export function hideBuildingSwitcher () {
    const switcher = document.querySelector('#building-switcher');
    if (switcher){
        gsap.to(switcher,{bottom: -100, opacity:0, duration: 1,onComplete:()=>{
                switcher.classList.add('hide');
                switcher.classList.remove('showed');
                resetBuildingSwitcherAnimation(switcher);
        }});
    }
}

export function showBuildingSwitcher () {
    if (config.features.privateHouseMode)
        return;
    
    let switcher = document.querySelector('#building-switcher');

    if (!switcher) {
        switcher = BuildingSwitch.add(UIRoot);
    }

    if (switcher.classList.contains('showed') || Buildings.getBuildingsInfoLength() <= 1){
        return;
    }

    document.querySelectorAll('#building-switcher .building-item.active').forEach(item => item.classList.remove('active'));

    const activeBuilding = Buildings.getActiveBuilding();
    switcher.querySelectorAll(`.building-item[data-building="${activeBuilding.name}"]`).forEach(item => item.classList.add('active'));
    const dropDown = switcher.querySelector('.buildings-dropdown');
    const activeElement = dropDown.querySelector(`.building-item[data-building="${activeBuilding.name}`);
    activeElement && activeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
    });

    gsap.fromTo(switcher,{bottom: -100,opacity: 0},{bottom:32, opacity:1, duration: 1,
        onStart:()=>{
            switcher.classList.remove('hide');
        },onComplete:()=>{
            resetBuildingSwitcherAnimation(switcher);
            switcher.classList.add('showed');
            setParametersDependsOnCanvasArea('building-switcher');
        }});
}

function resetBuildingSwitcherAnimation (switcher) {
    switcher.style.removeProperty('bottom');
}

export function showActiveBuilding () {
    const buildingToShow = Buildings.getActiveBuilding();


    if (buildingToShow && buildingToShow.modelGroup) {
        buildingToShow.activate();
        buildingToShow.modelGroup.visible = true;
        buildingToShow.isHide = false;
    }



    // return;
    // const mixer = GSAPAnimationMixer.getMixer('switchingBuilding');
    //
    // if (!buildingToShow.modelGroup) return;
    //     buildingToShow.modelGroup.traverse(mesh => {
    //         if (mesh.isMesh) {
    //             if (Array.isArray(mesh.material)) {
    //                 mesh.material.forEach(item => {
    //                     const animation = gsap.to(item, {
    //                         duration: GSAPAnimationMixer.duration,
    //                         opacity: item.userData.defaultSettings ? item.userData.defaultSettings.opacity : 1,
    //                         ease: GSAPAnimationMixer.ease,
    //                         onStart: () => {
    //                             item.transparent = true;
    //                             item.needsUpdate = true;
    //                             settingsData.bombBlock = true;
    //                             buildingToShow.modelGroup.visible = true;
    //                         },
    //                         // onUpdate: multimaterialNeedsUpdate,
    //                         onComplete: () => {
    //                             if (item.userData.defaultSettings)
    //                                 item.transparent = item.userData.defaultSettings.transparent;
    //                             buildingToShow.isHide = false;
    //                             settingsData.bombBlock = false;
    //                         }
    //                     });
    //
    //                     mixer.addAnimation(animation);
    //                 });
    //             } else {
    //                const animation = gsap.to(mesh.material, {
    //                     duration: GSAPAnimationMixer.duration,
    //                     opacity: 1,
    //                     ease: GSAPAnimationMixer.ease,
    //                     onStart: () => {
    //                         mesh.material.transparent = true;
    //                         mesh.material.needsUpdate = true;
    //                         settingsData.bombBlock = true;
    //                         buildingToShow.modelGroup.visible = true;
    //                     },
    //                     onComplete: () => {
    //                         mesh.material.transparent = config.resources.bundle?.material.transparent || false;
    //                         buildingToShow.isHide = false;
    //                         settingsData.bombBlock = false;
    //                     }
    //                 });
    //
    //                mixer.addAnimation(animation);
    //             }
    //         }
    //     });
}

export function hideBuildings () {
    if (config.features.privateHouseMode || isCylinderDisplayModeEqual('show all')) return;

    const buildingsToHide = Buildings.getDeactivatedBuildings();

    if (!buildingsToHide.length) return;


    buildingsToHide.forEach(building => {
        building.deactivate();
        building.modelGroup.visible = Boolean(config.features.buildingOpacity);
        building.isHide = true;
    });


    // const globalTimeLine = gsap.timeline({
    //     paused: true,
    //     onStart: () => settingsData.bombBlock = true,
    //     onComplete: () => settingsData.bombBlock = false
    // });

    // const mixer = GSAPAnimationMixer.getMixer(mode === 'switching' ? 'switchingBuilding' : 'cylinderEnter');
    // // const mixer = GSAPAnimationMixer.registerNewMixer('hideBuildings',false);
    // mixer.addCallback('onComplete',() => {
    //    buildingsToHide.forEach(building => {
    //        building.modelGroup.visible = Boolean(config.features.buildingOpacity);
    //        building.isHide = true;
    //    });
    // });
    //
    // buildingsToHide.forEach(building => {
    //     if (!building.modelGroup) return;
    //     // const tl = gsap.timeline({
    //     //     onComplete: () => {
    //     //         building.modelGroup.visible = Boolean(config.features.buildingOpacity);
    //     //         building.isHide = true;
    //     //     }
    //     // });
    //
    //     building.modelGroup.traverse(mesh => {
    //         if (mesh.isMesh) {
    //             if (Array.isArray(mesh.material)) {
    //                 mesh.material.forEach(item => {
    //                     const animation = gsap.to(item, {
    //                         duration: GSAPAnimationMixer.duration,
    //                         ease: GSAPAnimationMixer.ease,
    //                         // transparent: true,
    //                         onStart: () => {
    //                           item.transparent = true;
    //                           item.needsUpdate = true;
    //                         },
    //                         opacity: config.features.buildingOpacity ? config.features.buildingOpacity : 0,
    //                         // onUpdate: multimaterialNeedsUpdate
    //                     });
    //                     mixer.addAnimation(animation);
    //                 });
    //             } else {
    //                 const animation = gsap.to(mesh.material, {
    //                     duration: GSAPAnimationMixer.duration,
    //                     ease: GSAPAnimationMixer.ease,
    //                     // transparent: true,
    //                     onStart: () => {
    //                         mesh.material.transparent = true;
    //                         mesh.material.needsUpdate = true;
    //                     },
    //                     opacity: config.features.buildingOpacity ? config.features.buildingOpacity : 0,
    //                 });
    //                 mixer.addAnimation(animation);
    //             }
    //         }
    //     });
    //     // GSAPAnimationMixer.addToMixer(mode === 'switching' ? 'switchBuilding' : 'cylinderEnter');
    //     // globalTimeLine.add(tl,0);
    // });
    //
    // // globalTimeLine.play(0);
}

export function showOneBuildingMesh () {
    if (Buildings.oneMeshModel) {
        Buildings.oneMeshModel.visible = true;
    }
}

export function showAllBuildings () {
    const buildings = Buildings.getBuildingsArray();
   
    if (projectMode.AirMode.active) {
        
        if (Buildings.oneMeshModel) {
            Buildings.oneMeshModel.visible = false;
        }
        
        buildings.forEach(building => {
            building.modelGroup.visible = false;
            building.setLayer(0);
            building.isHide = false;
        });
        return;
    }
    
    const deactivatedBuildings = Buildings.getDeactivatedBuildings();

    // if (showWithoutAnimation) {
    deactivatedBuildings.forEach(building => {
        building.modelGroup.visible = true;
        building.setLayer(0);
        building.isHide = false;
    });

    buildings.forEach(building => {
        if (projectMode.LiteMode.isActive()){
            settingsData.poiIntersection.forEach(mesh => {
                if (!settingsData.objects_to_intersection.includes(mesh)) {
                    settingsData.objects_to_intersection.push(mesh);
                }
            });

            settingsData.additionalIntersectionObjects.forEach(mesh => {
                if (!settingsData.objects_to_intersection.includes(mesh)) {
                    settingsData.objects_to_intersection.push(mesh);
                }
            });

        } else {
            settingsData.poiIntersection.forEach(mesh => {
                if (!settingsData.objects_to_intersection.includes(mesh)) {
                    settingsData.objects_to_intersection.push(mesh);
                }
            });

            settingsData.additionalIntersectionObjects.forEach(mesh => {
                if (!settingsData.objects_to_intersection.includes(mesh)) {
                    settingsData.objects_to_intersection.push(mesh);
                }
            });

            settingsData.objects_to_intersection.push(...building.instances);
        }
    });


    //
    //     return;
    // // }
    // let mixer = GSAPAnimationMixer.getMixer('exitToOrbit');
    //
    // if (!mixer) {
    //     mixer = GSAPAnimationMixer.registerNewMixer('exitToOrbit');
    // }
    //
    // mixer.addCallback('onStart',() => {
    //     buildings.forEach(building => {
    //         if (building.isHide) {
    //             building.modelGroup.visible = true;
    //         }
    //     });
    // });
    //
    // mixer.addCallback('onComplete',() => {
    //     buildings.forEach(building => {
    //         if (building.isHide) {
    //             building.isHide = false;
    //         }
    //     });
    // });
    //
    // buildings.forEach(building => {
    //
    //     if (projectMode.LiteMode.isActive()){
    //         settingsData.objects_to_intersection.push(
    //             ...settingsData.poiIntersection,
    //             ...settingsData.additionalIntersectionObjects
    //         );
    //     } else {
    //         settingsData.objects_to_intersection.push(
    //             ...building.instances,
    //             ...settingsData.poiIntersection,
    //             ...settingsData.additionalIntersectionObjects
    //         );
    //     }
    //
    //     if (building.isHide){
    //
    //         // const tl = gsap.timeline({
    //         //     onStart: () => {
    //         //         building.modelGroup.visible = true;
    //         //     },
    //         //     onComplete: () => {
    //         //         building.isHide = false;
    //         //     }
    //         // });
    //         building.modelGroup.traverse(mesh => {
    //             if (mesh.isMesh) {
    //                 if (Array.isArray(mesh.material)) {
    //                     mesh.material.forEach(item => {
    //                         const animation = gsap.to(item, {
    //                             duration: GSAPAnimationMixer.duration,
    //                             ease: GSAPAnimationMixer.ease,
    //                             opacity: item.userData.defaultSettings ? item.userData.defaultSettings.opacity : 1,
    //                             onComplete: () => {
    //                                 if (item.userData.defaultSettings) {
    //                                     item.transparent = item.userData.defaultSettings.transparent;
    //                                 } else {
    //                                     item.transparent = config.resources.bundle.material.transparent || false;
    //                                 }
    //                             }
    //                         });
    //                         mixer.addAnimation(animation);
    //                     });
    //                 } else {
    //                     const animation = gsap.to(mesh.material, {
    //                         duration: GSAPAnimationMixer.duration,
    //                         ease: GSAPAnimationMixer.ease,
    //                         opacity: mesh.material.userData.defaultSettings ? mesh.material.userData.defaultSettings.opacity : 1,
    //                         onComplete: () => {
    //                             if (mesh.material.userData.defaultSettings) {
    //                                 mesh.material.transparent = mesh.material.userData.defaultSettings.transparent;
    //                             } else {
    //                                 mesh.material.transparent = config.resources.bundle.material.transparent || false;
    //                             }
    //                         }
    //                     });
    //                     mixer.addAnimation(animation);
    //                 }
    //             }
    //         });
    //
    //         // globalTimeLine.add(tl,0);
    //     }
    // });
    //
    // // globalTimeLine.play(0);
    //
    // // return Promise.all(animations);
}

export function closeUnitCard(buildingSwitching = false) {
    if (cardsData.multiplyCards && buildingSwitching) {
        if (UnitCardClass.cards.length > 1) {
            UnitCardClass.cards.forEach(card => {
                if (card.html.classList.contains('active')) {
                    const activeCard = card.html.getAttribute('data-engineid');
                    card.closeWebOrDesktopCard(card.html, activeCard);
                }
            });

            const card = UnitCardClass.findCard();
            card && card.compareCardToBuilding();

        } else {
            const card = UnitCardClass.findCard();
            card && card.compareCardToBuilding();
        }
    } else {
        if (UnitCardClass.findCard()?.html)
            UnitCardClass.closeMultipleCards();
    }
}

export async function enterToTheBuildingWithMaxAvailableApartments () {
    function getAvailableApartments() {
        return Buildings.getBuildingsArray().reduce((acc,value) =>{
            if (Object.keys(value.info).length){
                acc.push({
                    name: value.name,
                    availableApartments: value.info.availableApartments
                });
            }
    
            return acc;
        },[]);
    }
    
    let availableApartments = getAvailableApartments();

    if (projectMode.LiteMode.isActive() && projectMode.LiteMode.modeIs('schematic') && availableApartments.length === 0) {
        await new Promise(resolve => {
            const awaitBuildingsInterval = setInterval(() => {
                if (Buildings.getBuildingsArray().length) {
                    availableApartments = getAvailableApartments();
                    clearInterval(awaitBuildingsInterval);
                    resolve();
                }
            },200);
        })
    }

    const maxValue = Math.max(...availableApartments.map(building => building.availableApartments));
    const buildingWithMaxApartments = availableApartments.find(building => building.availableApartments === maxValue);
    if (!buildingWithMaxApartments) {
        return false;
    } else {
        projectMode.Cylinder.enter(Buildings.getBuilding(buildingWithMaxApartments.name));
        return true;
    }
}
